import AdditionalName from '../models/be/AdditionalName';

// This has been duplicated to Validation.cs.
// eslint-disable-next-line import/prefer-default-export
export const validateAdditionalNamesEditor = (additionalNames: AdditionalName[], props: Record<string, unknown>) => {
	const required = props.required !== undefined ? Boolean(props.required) : false;
	if (required && additionalNames.length === 0) {
		return 'At least one Additional Name is required.';
	}
	return null;
};
